import {
    CautionsTabLocationsView,
    ConsolidatedLocationView,
    EventPanelFormType,
} from '@mark43/cad-api';
import { Box } from '@cad-arc';
import { UseFormReturn } from 'react-hook-form';
import { EventPanelFormReadOnlyReportingPartyFields } from '../../../event-panel/event-panel-form/event-panel-form-read-only-reporting-party-fields';
import { FrEventFormFieldsSummary } from '../../fr-event-form-fields-summary';
import { FrEventLocationSelectValueDisplay } from '../../fr-event-location-select-value-display';
import { FrEventNearbyCautions } from '../../fr-event-nearby-cautions';

export const FrDispositionSummarySection = ({
    cautions,
    areCautionsLoading,
    eventLocation,
    eventForm,
    agencyTypeGlobalAttrId,
}: {
    cautions?: CautionsTabLocationsView;
    areCautionsLoading: boolean;
    eventLocation: ConsolidatedLocationView;
    eventForm: UseFormReturn<EventPanelFormType, any, undefined>;
    agencyTypeGlobalAttrId: number;
}) => {
    return (
        <>
            <Box mb={6}>
                <FrEventLocationSelectValueDisplay
                    showComplementaryContent={false}
                    cautions={cautions}
                    areCautionsLoading={areCautionsLoading}
                    specificEntityLocation={eventLocation}
                />
            </Box>
            <FrEventNearbyCautions
                areCautionsLoading={areCautionsLoading}
                cautions={cautions}
                marginBottom={6}
            />
            <FrEventFormFieldsSummary
                eventForm={eventForm}
                agencyTypeGlobalAttrId={agencyTypeGlobalAttrId}
            />
            <EventPanelFormReadOnlyReportingPartyFields />
        </>
    );
};
